module.exports = __webpack_public_path__ + "static/blueberry-f251b03295e398665c33d03156b7166d.svg";